const normalizeAnswer = (value) =>
  String(value == null ? "" : value)
    .trim()
    .toLowerCase();

export const getPteReadingBlankResultState = ({
  selectedAnswer = "",
  correctAnswer = "",
} = {}) => {
  const answerText = selectedAnswer || "-";

  return {
    answerText,
    isCorrect:
      !!selectedAnswer &&
      normalizeAnswer(selectedAnswer) === normalizeAnswer(correctAnswer),
  };
};
